import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const FinanceDisbursementAccountRoutes = defineRoute({
    record: {
        route: {
            path: "/finance-disbursement-account",
            component: () => loadView(import("./FinanceDisbursementAccountTable.vue")),
        },
    },
    create: {
        route: {
            path: "/finance-disbursement-account/create",
            component: () => loadView(import("./FinanceDisbursementAccountCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/finance-disbursement-account/update/:id",
            component: () => loadView(import("./FinanceDisbursementAccountUpdate.vue")),
        },
        build(id: string) {
            return `/finance-disbursement-account/update/${id}`;
        },
    },
});
